module.exports = __webpack_public_path__ + "images/illustrations/icons/icon-award-ribbon2-7e99e087dccc41695177dfdb19f44a90.webp";